"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEST_TRANSACTION_TYPES = exports.CARD_TYPES = exports.MAX_UNVERIFIED_CARDS = exports.MAX_CARD_BALANCE = exports.CARD_VALUE_LIMITS = exports.AGGREGATE_LIMITS = exports.VARIABLE_FEE_PERCENTAGE = exports.FIXED_FEE = exports.FIRST_TRANSACTION_FEE = void 0;
exports.FIRST_TRANSACTION_FEE = {
    UNVERIFIED: 0,
    VERIFIED: 0,
};
exports.FIXED_FEE = {
    AIRTM: {
        RELOAD: 0,
        UNLOAD: {
            NON_RELOADABLE_MULTI_USE: 0,
            RELOADABLE_MULTI_USE: 0,
        },
        UNVERIFIED: 1.1,
        VERIFIED: 0,
    },
    BEST: {
        RELOAD: 2,
        UNLOAD: {
            NON_RELOADABLE_MULTI_USE: 2.75,
            RELOADABLE_MULTI_USE: 2,
        },
        UNVERIFIED: 2.6,
        VERIFIED: 4.95,
    },
};
exports.VARIABLE_FEE_PERCENTAGE = {
    AIRTM: 1,
    BEST: {
        UNVERIFIED: 3,
        VERIFIED: 3,
    },
};
exports.AGGREGATE_LIMITS = {
    UNVERIFIED: 1000,
    VERIFIED: 2400,
};
exports.CARD_VALUE_LIMITS = {
    MAX_UNVERIFIED: 100,
    MAX_VERIFIED: 800,
    MIN_UNVERIFIED: 1.25,
    MIN_VERIFIED: 1,
};
exports.MAX_CARD_BALANCE = 2400;
exports.MAX_UNVERIFIED_CARDS = 10;
exports.CARD_TYPES = {
    NON_RELOADABLE_SINGLE_USE: 'NON_RELOADABLE_SINGLE_USE',
    NON_RELOADABLE_MULTI_USE: 'NON_RELOADABLE_MULTI_USE',
    RELOADABLE_MULTI_USE: 'RELOADABLE_MULTI_USE',
};
exports.BEST_TRANSACTION_TYPES = {
    DECLINE: 'Redeem',
    OUTSTANDING_PURCHASE: 'Redeem',
    PURCHASE: 'Redeem',
    RETURNS: 'FundPurchaseReturn',
    REVERSAL: 'Reversal',
};
